var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modals',{attrs:{"title":_vm.title,"validateBeforeClose":_vm.validateBeforeClose,"display":_vm.display,"parentTag":'form',"novalidate":'novalidate'},on:{"show":_vm.closeGlobalFormModal},scopedSlots:_vm._u([{key:"modal-content",fn:function(){return [_c('div',{staticClass:"change-reason"},[_c('div',{staticClass:"change-reason__comment"},[_c('Textarea',{attrs:{"label":_vm.labelText,"placeholder":_vm.placeholder,"rows":4,"cols":30,"maxLength":_vm.maxLength,"required":_vm.required},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1)])]},proxy:true},{key:"modal-footer",fn:function(){return [_c('ButtonGroup',{attrs:{"items":[
				{
					className: 'btn--primary',
					labelText: _vm.labelButtons.accept,
					disabled: !_vm.hasComment,
					btnClick: _vm.acceptAction
				},
				{
					className: 'btn--link',
					labelText: _vm.labelButtons.cancel,
					btnClick: _vm.cancelAction
				}
			]}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }